module.exports = __webpack_public_path__ + "static/img/sev-eye-severance.fd9c1e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/sev-eye-severance.jpg
// module id = rHaR
// module chunks = 0